
import { requestOfPut,requestOfPost, requestOfGet } from "../utils/http"
const baseUrl = 'wechath5/zh-cn/v1/registration'



export function getProductList(param) {
  return requestOfPost(`${baseUrl}/product`, param)
}
export function getJishiList(param) {
  return requestOfPost(`${baseUrl}/jishi`, param)
}
export function getPeriodsList(param) {
  return requestOfPost(`${baseUrl}/timespan`, param)
}
export function getBookRegisterDetail(param) {
  return requestOfGet(`${baseUrl}/info/${param.Id}`, param)
}
export function getBookRegisterHistory(param) {
  return requestOfGet(`${baseUrl}/list`, param)
}
export function submitBookRegister(param) {
  return requestOfPost(`${baseUrl}/add`, param)
}
export function cancelBookRegister(param) {
  return requestOfPost(`${baseUrl}/cancel`, param)
}
export function getBookRegisterConfig(param) {
  return requestOfGet(`${baseUrl}/setting`, param)
}

